import axios from 'axios';

const basePath = '/api/delivery/cities';

export const cityService = {
  // Obtener lista completa de ciudades activas
  getCities: async (params) => {
    const response = await axios.get(`${basePath}/`, { params });
    return response.data;
  },

  // Obtener detalle de una ciudad específica
  getCityDetail: async (id) => {
    const response = await axios.get(`${basePath}/${id}/`);
    return response.data;
  },

  // Crear nueva ciudad (o reactivarla si existía)
  createCity: async (cityData) => {
    const response = await axios.post(`${basePath}/`, cityData);
    return response.data;
  },

  // Actualizar ciudad (PATCH)
  updateCity: async (id, cityData) => {
    const response = await axios.patch(`${basePath}/${id}/`, cityData);
    return response.data;
  },

  // Eliminar (desactivar) ciudad
  deleteCity: async (id) => {
    const response = await axios.delete(`${basePath}/${id}/`);
    return response.data;
  },

  // Obtener lista de provincias
  getProvinces: async () => {
    const response = await axios.get('/api/delivery/provinces/');
    return response.data.results || response.data;
  },

  // Buscar ciudades filtradas (para autocompletar)
  searchCities: async (provinceId, search) => {
    const response = await axios.get(`${basePath}/`, {
      params: {
        active_only: false,
        province_id: provinceId,
        search: search
      }
    });
    return response.data.results || response.data;
  }
};

export default cityService;
